var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Container, Box } from "@mui/material";
import CartilhaPage from "../../components/CartilhaPage";
import styles from "../../components/HomePage/index.module.css";
import { useHistory, useParams } from "react-router-dom";
import { BackButtonWithTitle } from "@opala-ds/react";
import { useWebgate } from "@xvia/webgate-connect";
var Cartilha = function (_a) {
    var cartilha = _a.cartilha;
    var _b = useParams(), sigla = _b.sigla, idCartilha = _b.idCartilha;
    var history = useHistory();
    var handleBotaoVoltar = function () {
        history.goBack();
    };
    var portalConnect = useWebgate().portalConnect;
    return (_jsxs(Container, __assign({ id: "container-index b2" }, { children: [_jsx(Box, __assign({ className: styles.header }, { children: _jsx(BackButtonWithTitle, { textButton: "Voltar", textTitle: "Cartilhas Informativas", hideBackButton: portalConnect === null || portalConnect === void 0 ? void 0 : portalConnect.isRunningInWebview(), onClick: handleBotaoVoltar }) })), _jsx(Box, { children: _jsx("div", { children: _jsx(CartilhaPage, { sigla: sigla || "", id: idCartilha || "" }) }) })] })));
};
export default Cartilha;
